import { connectDeep } from 'redux-utils';
import ManageTiles from '../../components/v2/ManageTiles/index';
import App from '../../models/app';

const mapStateToProps = (state: any) => {
  const { registry } = state;

  const {
    installed: {
      tileStatuses: installedTiles
    }
  } = registry;

  let tiles = [];
  if (installedTiles && installedTiles.length > 0) {
    tiles = installedTiles.map((tile: any) => App.selectFromState(tile.tileId, state))
  }

  return {
    tiles
  };
};

export default connectDeep(mapStateToProps, null)(ManageTiles);